import { render, staticRenderFns } from "./card-coupon-module.vue?vue&type=template&id=5eeb8c5d&scoped=true&lang=pug&"
import script from "./card-coupon-module.vue?vue&type=script&lang=js&"
export * from "./card-coupon-module.vue?vue&type=script&lang=js&"
import style0 from "./card-coupon-module.vue?vue&type=style&index=0&id=5eeb8c5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeb8c5d",
  null
  
)

export default component.exports